export const translations = {
  // VSteps Page
  heroDescription: "Use real-world leg movement to power your Video game character. Walk or run in place to move in-game—it's that simple.",
  downloadHub: "Download Desktop Hub",
  openMobile: "Launch VSteps Mobile",
  getStarted: "Get Started",
  quickSetup: "Get Started in Seconds",
  setupGuide: "Quick Setup Guide",
  step1Title: "Install",
  step1Desc: "Download and install the VSteps Desktop Hub on your PC",
  step2Title: "Open",
  step2Desc: "Open App through your Android / iOS browser and login",
  step3Title: "Connect",
  step3Desc: "Pair the phone, hold still for 3 seconds, then place in pocket",
  step4Title: "Play",
  step4Desc: "That's it! Walk or Run in any Video Game!",
  customization: "Fine-Tune Your Experience",
  customizationTitle: "Customization Controls",
  customizationDesc: "Simple but powerful settings to match your playstyle",
  trigger: "Trigger",
  triggerDesc: "Walking sensitivity adjustment",
  response: "Response",
  responseDesc: "Lower = faster response but may trigger accidentally. Higher = smoother but may feel laggy.",
  hold: "Hold",
  holdDesc: "Window for how long 'W' stays held. If character stutters, increase this value.",
  enableSprint: "Enable Sprint",
  sprintDesc: "Adjust running sensitivity",
  enabled: "Enabled",
  disabled: "Disabled",
  remapFeature: "Keyboard and Xbox Controller Remap Feature",
  remapDesc: "Customize key bindings for movement and sprint to match your in-game settings.",
  competitive: "Beyond Solo Play",
  competitiveTitle: "Competitive Ecosystem",
  competitiveDesc: "Connect, compete, and master your movement in our integrated community platform",
  friends: "Friends",
  friendsDesc: "Sync with your squad and track live movement stats. Fitness is better shared.",
  pvpArena: "Team Arena",
  pvpDesc: "Movement-based lobbies designed to test your Stamina against or with other players/teams. Zero lag, zero excuses.",
  trophies: "Trophies",
  trophiesDesc: "Collect trophies and unlock achievements. V4llue gains while gaming.",
  faq: "FAQ",
  faqTitle: "Got Questions?",
  faqSubtitle: "Frequently Asked",
  pricing: "Pricing",
  allRightsReserved: "© 2025 V4llued. All rights reserved.",
  privacy: "Privacy",
  terms: "Terms",
  support: "Support",
  // FAQ Questions
  faqQ2: "Does V4llued Steps work with all games?",
  faqA2: "V4llued Steps works with any game that accepts xbox controller or standard keyboard inputs (W, A, S, D). Our JS backend simulates physical key presses at the system level, making it indistinguishable from actual keypresses to any application.",
  faqQ3: "How do I calibrate the forward direction?",
  faqA3: "Simply tap 'START' in the mobile app. Hold still for 3 seconds, the system will instantly calibrate, sensors will then be relative to your movement.",
  faqQ4: "Why isn't the Xbox Controller working?",
  faqA4: "Try this step by step process: Press Connect on VSteps Desktop first, then pair the controller before launching the game.",
  faqQ5: "Can I use other controllers besides Xbox?",
  faqA5: "Yes, you can emulate Nintendo Joy-Con, PS4 (DS4), and PS5 (DS5) controllers like an Xbox controller using a free app called DS4Windows. The step-by-step guide will be on the Resources page. If you want to use these controllers on a gaming console instead of a PC, you will need a device called a XIM Matrix.",

  
  // Pricing Page
  selectPlan: "SELECT FITNESS GAMING PLAN:",
  feature0: "Keyboard & Controller outputs",
  monthlyMembership: "1 MONTH MEMBERSHIP",
  yearlyMembership: "12 MONTH MEMBERSHIP",
  lifetimeMembership: "LIFETIME MEMBERSHIP",
  perMonth: "/month",
  perYear: "/year",
  oneTime: "one-time",
  monthlyDesc: "1 Month of full access. Recurring charge.",
  yearlyDesc: "1 Year of full access. Recurring charge.",
  lifetimeDesc: "Permanent Lifetime access. One-time payment.",
  bestValue: "BEST VALUE",
  feature1: "Precision step detection with advanced running movement feature",
  feature3: "Access to Super Fun Team Arena Lobbies",
  feature4: "Desktop to mobile app connection with custom key binds",
  initiate: "UPGRADE",
  securityInfo: "All Transactions Secured | 256-Bit Encryption",
  backToHome: "Back to Home",
  
  // Privacy Page
  privacyPolicy: "Privacy Policy",
  lastUpdatedPrivacy: "Last updated: January 30, 2026",
  introduction: "Introduction",
  privacyIntro: "V4llued Steps is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and desktop hub.",
  infoWeCollect: "Information We Collect",
  deviceInfo: "Device Information",
  deviceInfoDesc: "We collect device motion data to enable our precision sensor features. This includes gyroscope and accelerometer data used for movement tracking.",
  usageData: "Usage Data",
  usageDataDesc: "We may collect information about how you interact with our app, including features used, settings configured, and app performance metrics.",
  networkInfo: "Network Information",
  networkInfoDesc: "To enable communication between your mobile device and desktop hub, we collect local network information when both devices are connected to the same Wi-Fi network.",
  howWeUse: "How We Use Your Information",
  howWeUseIntro: "We use the collected information to:",
  useItem1: "Provide and maintain our precision sensor services",
  useItem2: "Enable communication between your mobile app and desktop hub",
  useItem3: "Improve app performance and user experience",
  useItem4: "Troubleshoot technical issues",
  useItem5: "Develop new features and functionality",
  dataStorage: "Data Storage and Security",
  dataStorageDesc: "All sensor data is processed locally on your device. We do not transmit your movement data to external servers. Communication between your mobile device and desktop hub occurs only on your local network and is not stored permanently.",
  thirdParty: "Third-Party Services",
  thirdPartyDesc: "V4llued Steps may use third-party services for analytics and crash reporting to improve app stability and performance. These services may collect anonymized usage data according to their own privacy policies.",
  yourRights: "Your Rights",
  yourRightsIntro: "You have the right to:",
  rightItem1: "Request deletion of your data",
  rightItem2: "Opt-out of data collection by uninstalling the app",
  rightItem3: "Update your app settings and preferences at any time",
  changesToPolicy: "Changes to This Policy",
  changesToPolicyDesc: "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the \"Last updated\" date.",
  contactUs: "Contact Us",
  contactUsDesc: "If you have any questions about this Privacy Policy, please contact us through our support email at V4LLUED@gmail.com or via the contact information provided in the app.",
  
  // Terms Page
  termsConditions: "Terms & Conditions",
  lastUpdatedTerms: "Last updated: February 14, 2026",
  agreementToTerms: "Agreement to Terms",
  agreementDesc: "By accessing and using V4llued Steps, you accept and agree to be bound by the terms and conditions of this agreement. If you do not agree to abide by these terms, please do not use this application.",
  licenseUsage: "License and Usage",
  licenseDesc: "V4llued Steps grants you a personal, non-exclusive, non-transferable license to use the mobile application and desktop hub for personal gaming and fitness purposes.",
  youMayNot: "You may not:",
  licenseItem1: "Modify, reverse engineer, or decompile the application",
  licenseItem2: "Use the application for commercial purposes without authorization",
  licenseItem3: "Distribute or share your license with others",
  licenseItem4: "Use the application to violate any laws or regulations",
  licenseItem5: "Attempt to circumvent any security features or limitations",
  healthSafety: "Health and Safety",
  healthDesc: "V4llued Steps is a physical activity application. By using this app, you acknowledge that:",
  healthItem1: "Physical activity carries inherent risks of injury",
  healthItem2: "You are responsible for your own health and safety",
  healthItem3: "You should consult a physician before beginning any exercise program",
  healthItem4: "You should stop using the app if you experience pain or discomfort",
  healthItem5: "V4llued Steps is not liable for any injuries sustained while using the application",
  gameCompatibility: "Game Compatibility",
  gameCompatibilityDesc: "V4llued Steps simulates keyboard and controller inputs to enable movement in games. While we strive for broad compatibility, we cannot guarantee that V4llued Steps will work with all games or applications. Some games may have anti-cheat systems that detect simulated inputs. Use at your own discretion.",
  networkRequirements: "Network and Device Requirements",
  networkRequirementsDesc: "V4llued Steps requires a stable local network connection between your mobile device and desktop hub. You are responsible for ensuring your devices meet the minimum requirements and maintaining your network infrastructure.",
  subscriptionPayments: "Subscription and Payments",
  subscriptionDesc: "V4llued Steps offers subscription-based services:",
  subItem1: "Subscriptions are billed automatically at the selected interval",
  subItem2: "You may cancel your subscription at any time",
  subItem3: "Refunds are subject to our refund policy",
  subItem4: "Prices are subject to change with notice",
  subItem5: "Payment processing is handled by third-party payment providers",
  competitiveFeatures: "Competitive Features and Fair Play",
  competitiveFeaturesIntro: "When using V4llued Steps' competitive features (PVP Arena, Trophies, Leaderboards), you agree to:",
  compItem1: "Play fairly and not attempt to manipulate or cheat the system",
  compItem2: "Not use automated tools or bots to gain unfair advantages",
  compItem3: "Respect other players and maintain appropriate conduct",
  compItem4: "Accept that V4llued Steps may disqualify or ban users who violate fair play policies",
  intellectualProperty: "Intellectual Property",
  intellectualPropertyDesc: "All content, trademarks, logos, and intellectual property related to V4llued Steps remain the property of V4llued Steps. You may not use our branding or content without explicit permission.",
  limitationLiability: "Limitation of Liability",
  limitationLiabilityDesc: "V4llued Steps is provided \"as is\" without warranties of any kind. We are not liable for any damages, injuries, or losses resulting from the use of our application. This includes, but is not limited to, physical injuries, device damage, data loss, or game account issues.",
  userConduct: "User Conduct",
  userConductIntro: "You agree not to:",
  conductItem1: "Use V4llued Steps to harass, abuse, or harm others",
  conductItem2: "Upload or transmit malicious code or viruses",
  conductItem3: "Impersonate others or misrepresent your identity",
  conductItem4: "Violate any applicable laws or regulations",
  conductItem5: "Interfere with the proper functioning of the application",
  termination: "Termination",
  terminationDesc: "We reserve the right to suspend or terminate your access to V4llued Steps at any time for violations of these terms or for any other reason at our discretion. Upon termination, you must cease all use of the application.",
  changesToTerms: "Changes to Terms",
  changesToTermsDesc: "We may modify these terms at any time. Continued use of V4llued Steps after changes constitutes acceptance of the new terms. We will notify users of significant changes through the application or email.",
  governingLaw: "Governing Law",
  governingLawDesc: "These terms are governed by and construed in accordance with applicable laws. Any disputes arising from these terms or use of V4llued Steps shall be resolved through binding arbitration.",
  contactInfo: "Contact Information",
  contactInfoDesc: "If you have questions about these Terms & Conditions, please contact us at V4LLUED@gmail.com.",
  
  // AccessGranted Page
  accessGranted: "ACCESS GRANTED",
  operatorStatus: "OPERATOR STATUS:",
  active: "ACTIVE",
  welcomeFitness: "Welcome to the world of FITNESS GAMING",
  subscriptionActive: "Your VSteps subscription is now active. Download the necessary components to begin your training regimen.",
  desktopHub: "Desktop Hub",
  desktopHubDesc: "Core bridge system for PC integration",
  downloadHubBtn: "Download Hub",
  mobileApp: "Mobile App",
  mobileAppDesc: "Pocket controller with motion tracking",
  downloadAppBtn: "Download App",
  nextSteps: "Next Steps",
  nextStep1: "Install the Desktop Hub on your PC",
  nextStep2: "Download the Mobile App on your smartphone",
  nextStep3: "Connect both devices on the same Wi-Fi network",
  nextStep4: "Calibrate your sensors and Enjoy!",
  returnToBase: "Return to Base",
  
  // Checkout Page
  billing: "Billing",
  secureClearance: "SECURE CLEARANCE PROTOCOL",
  orderSummary: "ORDER SUMMARY",
  selectedPackage: "Selected Package:",
  finalTotal: "FINAL TOTAL:",
  startFitnessGaming: "START YOUR FITNESS GAMING // INSTANT ACTIVATION",
  backToPricing: "Back to Pricing"
};

export const getTranslation = (key) => {
  return translations[key] || key;
};